import { meta } from "./_meta";
import styles from './_hcp-peerconnect.module.scss';
import FindDoctorTool from "@/components/find-doctor-tool";
import Button from "@/components/button";

export default function HcpPeerConnect() {

  return (
    <div className={styles.container}>
      <FindDoctorTool
        isHcp
        instructions={<>
          Use filters to identify physicians with experience treating CAH—whether they&rsquo;ve published on CAH, led or participated in clinical trials, or currently practice at a <Button
            href="https://caresfoundation.org/centers-of-excellence/"
            leaveSiteLink
          >Comprehensive Care Center</Button> or similar facility.
        </>}
      >
        <h1>Looking to connect with colleagues who treat CAH?</h1>
        <p>
          PeerConnect helps you find endocrinologists experienced in CAH care. These colleagues can share their insights, provide opportunities for collaboration, or be resources for patients moving away from your practice.*
        </p>
      </FindDoctorTool>
    </div>
  );
}

HcpPeerConnect.getLayoutProps = (_pageProps, _router) => ({
  customClass: styles.layout,
  meta,
  hero: null,
});